/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fields, FormGroups, FormGroupsWithFields } from '../types/Form';

export const getGroupedFields = (
  fields: Fields<any>,
  groups: FormGroups = {}
) => {
  const groupsWithFields: FormGroupsWithFields = {};

  // Filter out hidden fields before grouping
  Object.entries(fields).forEach(([name, field]) => {
    // Skip hidden fields entirely
    if (field.hidden) {
      return;
    }

    const groupKey = field.group ?? `single-${name}`;
    if (!groupsWithFields[groupKey]) {
      groupsWithFields[groupKey] = {
        ...(groups ? groups[groupKey] ?? {} : {}),
        fields: {
          [name]: field
        }
      };
    } else {
      groupsWithFields[groupKey].fields[name] = field;
    }
  });

  return groupsWithFields;
};
